import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const cannedFiles_routes = [
  {
    path: 'canned-files',
    name: 'canned-files',
    meta: {
      permissions: 'read-canned-files',
      breadcrumbs: settingsBreadcrumbs({
        label: 'global.sidebar.canned_trans',
        route: { name: 's-canned-files' },
      }),
    },
    children: [
      {
        path: '',
        name: 's-canned-files',
        component: () => import('@/views/System/Settings/CannedFiles/CannedList.vue'),
        meta: {
          permissions: 'read-canned-files',
        },
      },
    ],
  },
];

export default cannedFiles_routes;
